<template>
  <div>
    <PageTitleVue class="uppercase" :subTitle="'Horario atual: ' + currentTime">
      Registrar afastamento
    </PageTitleVue>

    <Form :descriptionTitle="'Registre o motivo da sua ausência'">
      <div class="w-full flex justify-center">
        <CreateButton
          @click="afastar"
          :label="'Registrar'"
        />
      </div>
    </Form>
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import AfastService from '../services/afastam.service'
import Form from './Form.vue'
import { cleanAllFormFields, setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { useGeolocation } from '@/composable/useGeolocation'
import { showToast as toast } from '@/helpers/UseToasts'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { dataAfastamento } from '../store'
import { storeApp } from '@/store'
import * as yup from '../../../validator'

const appStore = storeApp.state
const store = dataAfastamento
let permissions = localStorage.getItem('__permissions')
let permissionArray = permissions?.split(',');
const uploadPermission = ref(
  permissionArray.includes('afas_fun')
)

const currentTime = ref(new Date().toLocaleTimeString())
const interval = ref(null)

const updateClock = () => {
  currentTime.value = new Date().toLocaleTimeString();
}

const schema = yup.object().shape({
  type: yup.string().required('É necessário informar o tipo').label('Tipo')
})

async function afastar () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = (await validateFormField(schema, store.state))

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  const data = store.state

  // upload file
  if (data.doc) {
    await AfastService.uploadFile(data.doc)
      .then(res => {
        appStore.loading = false

        data.docName = res.data

        toast(
          'Sucesso',
          'Seu arquivo foi registrado',
          'success'
        )
      }).catch(err => {
        toast(
          'Aviso',
          'Seu arquivo não foi salvo',
          'error'
        )
      })
  }
    
  delete data.doc
  // delete data.collabs
  data.docOriginalName = data.docName

  await AfastService.register(data)
    .then((res) => {
      appStore.loading = false

      if (res.data.info) {
        return toast(
          'Protege informa: ',
          res.data.message,
          'info'
        )
      }

      if (res.data.success) {
        toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }
    }).catch((err) => {
      appStore.loading = false

      if (err?.response?.data?.error || err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar horario',
        'error'
      )
    })
}

async function getCollabCombo() {
  await AfastService.getAllCollabs()
    .then(res => {
      store.dispatch('setCollabsCombo', res.data);
    }).catch(err => {
      console.log(err);
    })
}

onMounted(() => {
  store.commit('reset')
  if(uploadPermission)
    Promise.all([
      getCollabCombo()
    ])

  interval.value = setInterval(updateClock, 1000);
})

onBeforeUnmount(() => {
  clearInterval(interval);
})
</script>
